// External Dependencies
import { useQuery } from '@tanstack/react-query';
import { InvoicesIndexRequest } from '@presto-assistant/api_types/api/admin/invoices';

// Internal Dependencies
import { prestoAdminApiClient } from 'utils/api/apiClient';

export const useGetAllInvoices = (queryParams: InvoicesIndexRequest['query']) => {
  return useQuery({
    queryFn: () => prestoAdminApiClient.v1.invoices.index({
      query: queryParams,
    }),
    queryKey: ['getAllInvoices', queryParams],
  });
};

export const useGetInvoice = (invoiceId: string) => {
  return useQuery({
    queryFn: () =>
      prestoAdminApiClient.v1.invoices.show({ params: { invoiceId } }),
    queryKey: ['getInvoice', invoiceId],
  });
};
